import { Component } from '@verndale/core';
import anime from 'animejs/lib/anime.es';
import createScrollShapes from '../helpers/createScrollShapes';
import { keyCode } from '../helpers/variables';

class FeaturedContentTabsRow extends Component {
  setupDefaults() {
    this.dom = {
      tabs: this.el.querySelectorAll('.featured-content-tabs-row__tab'),
      panels: [...this.el.querySelectorAll('.featured-content-tabs-row__panel')]
    };

    this.buildShapes();
    this.setSelectedTab(0);
  }

  addListeners() {
    this.dom.tabs.forEach((tab, index) => {
      tab.index = index;
      tab.addEventListener('click', this.handleTabClick.bind(this));
      tab.addEventListener('keydown', this.handleKeyDown.bind(this));
      tab.addEventListener('keyup', this.handleKeyUp.bind(this));
    });
  }

  buildShapes() {
    const { offsetHeight } = this.el;

    this.dom.shapes = createScrollShapes({
      containerEl: this.el,
      count: 2,
      prefix: 'featured-content-tabs-row__',
      offset: offsetHeight * 0.2
    });
  }

  setSelectedTab(selectedIndex) {
    this.dom.tabs.forEach((tab, index) => {
      tab.setAttribute('aria-selected', index === selectedIndex);

      if (index === selectedIndex) {
        tab.removeAttribute('tabindex');
      } else {
        tab.setAttribute('tabindex', -1);
      }
    });

    const activePanel = this.dom.panels.find(panel =>
      panel.classList.contains('featured-content-tabs-row__panel--active')
    );
    const selectedPanel = this.dom.panels[selectedIndex];

    if (activePanel) {
      this.hidePanel(activePanel, () => {
        this.showPanel(selectedPanel);
      });
    } else {
      this.showPanel(selectedPanel);
    }
  }

  hidePanel(panel, callback) {
    anime({
      targets: panel,
      opacity: [1, 0],
      easing: 'linear',
      duration: 200,
      complete: () => {
        panel.classList.remove('featured-content-tabs-row__panel--active');
        callback();
      }
    });
  }

  showPanel(panel) {
    panel.classList.add('featured-content-tabs-row__panel--active');
    anime({
      targets: panel,
      opacity: [0, 1],
      easing: 'linear',
      duration: 200
    });
  }

  handleTabClick(e) {
    this.setSelectedTab(e.target.index);
  }

  handleKeyDown(e) {
    const key = e.keyCode;

    switch (key) {
      case keyCode.END:
        e.preventDefault();
        // Activate last tab
        this.dom.tabs[this.dom.tabs.length - 1].focus();
        break;
      case keyCode.HOME:
        e.preventDefault();
        // Activate first tab
        this.dom.tabs[0].focus();
        break;
      default:
        break;
    }
  }

  handleKeyUp(e) {
    const key = e.keyCode;
    const { target } = e;

    switch (key) {
      case keyCode.LEFT:
        if (target.index === 0) {
          this.dom.tabs[this.dom.tabs.length - 1].focus();
        } else {
          this.dom.tabs[target.index - 1].focus();
        }
        break;
      case keyCode.RIGHT:
        if (target.index === this.dom.tabs.length - 1) {
          this.dom.tabs[0].focus();
        } else {
          this.dom.tabs[target.index + 1].focus();
        }
        break;
      default:
        break;
    }
  }
}

export default FeaturedContentTabsRow;
